import { Link } from 'react-router-dom';

export const ConditionalLink = ({ to, condition = true, children, ...props }) => {
  if (!condition || !to) {
    return (
      <div {...props}>
        {children}
      </div>
    );
  }

  return (
    <Link to={to} {...props}>
      {children}
    </Link>
  );
};